export default {
  filterAll: 'All',
  filterOpen: 'Open',
  filterClosed: 'Closed',
  filterRequiresAttention: 'Unread',
  filterSummary: '{visible} of {total}',
  filterAriaLabel: 'Filter conversations',
};
